import ng from 'angular';

import { InformationNodeObject } from '@/atomic-components';
import { PaymentMethodOption } from "@/atomic-components";
import './payment-options.scss';

export type PaymentMethod = 'postpaid' | 'card' | 'paypal' | 'others' | 'prepaid' | 'onAccount';

export class TemplateAccountActivationPaymentOptionsController {
    public static $inject: string[] = [
        '$translate',
    ];

    public creditcardPaymentLogos = [
        {

            url: '/assets/images/logos/payment/creditcard/visa.svg',
            alt: 'Payment Logo Visa',
            class: 'h-[1.15em] rounded',
        },
        {

            url: '/assets/images/logos/payment/creditcard/mastercard.svg',
            alt: 'Payment Logo Mastercard',
            class: 'h-[1.15em] rounded',
        },
        {

            url: '/assets/images/logos/payment/creditcard/american-express.svg',
            alt: 'Payment Logo American Express',
            class: 'h-[1.15em] rounded',
        },
        {

            url: '/assets/images/logos/payment/creditcard/cartes-bancaires.svg',
            alt: 'Payment Logo Cartes Bancaires',
            class: 'h-[1.15em] rounded',
        },
        {

            url: '/assets/images/logos/payment/creditcard/diners.svg',
            alt: 'Payment Logo Diners Club',
            class: 'h-[1.15em] rounded',
        },
    ]

    public otherPaymentLogos = [
        {
            url: '/assets/images/logos/payment/others/bancontact.svg',
            alt: 'Payment Logo Bancontact',
            class: 'h-[1.15em] rounded',
        },
        {
            url: '/assets/images/logos/payment/others/ideal.svg',
            alt: 'Payment Logo iDEAL',
            class: 'h-[1.15em] rounded',
        },
        {
            url: '/assets/images/logos/payment/others/amazon-pay.svg',
            alt: 'Payment Logo Amazon',
            class: 'h-[1.15em] rounded',
        },
    ]

    public paypalLogo = {
        url: '/assets/images/logos/payment/paypal.svg',
        alt: 'Payment Logo Paypal',
        class: 'h-[0.85em] mt-[0.15em]',
    };

    public sepaLogo = {
        url: '/assets/images/logos/payment/sepa.svg',
        alt: 'Payment Logo SEPA',
        class: 'h-[0.95em] mt-[0.1em]',
    };


    public paymentMethod: PaymentMethod;
    public paymentMethods: PaymentMethodOption[] = [];
    public sepaData = {
        accountHolder: '',
        iban: '',
        bic: '',
    };

    public showPrepaid = false;
    public sepaFormIsValid = false;
    public prepaidAccepted = false;
    public variant: string | null;

    public paymentNoticeForGovernmentInstitutions: InformationNodeObject;

    constructor(
        private $translate: ng.translate.ITranslateService,
    ) {}

    public $onInit = () => {
        if (this.variant === 'CSO.net') {
            this.showPrepaid = true;
        }
        this.paymentNoticeForGovernmentInstitutions = {
            headline: this.$translate.instant('TR_030321-523a0f_TR'),
            text: [this.$translate.instant('TR_030321-5f427b_TR')],
        };
        this._fillPaymentMethods();
    }

    private _fillPaymentMethods = () => {
        this.paymentMethod = 'postpaid';
        // ugly if, can change when paymentmethod comes from backend
        if (this.variant === 'CSO.net') {
            this.paymentMethods.push({type: 'postpaid', label: this.$translate.instant('TR_090119-e5076a_TR')});
            this.paymentMethods.push({type: 'onAccount', label: this.$translate.instant('TR_060819-c8af3e_TR')});
            return;
        }
        this.paymentMethods.push({type: 'postpaid', label: this.$translate.instant('TR_090119-e5076a_TR')});
        this.paymentMethods.push({type: 'card', label: this.$translate.instant('TR_090119-aa221e_TR')});
        this.paymentMethods.push({type: 'paypal', label: this.$translate.instant('TR_090119-efbad6_TR')});
        this.paymentMethods.push({type: 'others', label: this.$translate.instant('TR_130625-a7f504_TR')});
        this.paymentMethods.push({type: 'prepaid', label: this.$translate.instant('TR_020725-db805f_TR')});
    }

    public get paymentPanelTitle(): string {
        return this.$translate.instant('TR_080119-5c34c3_TR');
    }

    public get selectedPaymentMethod() {
        return this.paymentMethod;
    }

    public linkClicked() {
        this.showPrepaid = true;
    }
}

export class TemplateAccountActivationPaymentOptionsComponent implements ng.IComponentOptions {
    public bindings = {
        paymentMethod: '=',
        token: '<',
        sepaData: '=',
        sepaFormIsValid: '=',
        prepaidAccepted: '=',
        variant: '<',
    };
    public template = require('./payment-options.html');
    public controller = TemplateAccountActivationPaymentOptionsController;
}
